import React from 'react';
import { Layout, Model, IJsonModel } from 'flexlayout-react';
import 'flexlayout-react/style/dark.css'; // Use dark theme for better IDE experience
import SimpleFileTree from './SimpleFileTree';
import EditorArea from './EditorArea';
import TerminalEmulator from './TerminalEmulator';

const LayoutManager: React.FC = () => {
  // Define the layout model
  const json: IJsonModel = {
    global: {
      tabEnableClose: false,
      tabEnableDrag: true,
      tabSetEnableMaximize: true,
      tabSetEnableTabStrip: true
    },
    borders: [],
    layout: {
      type: "row",
      weight: 100,
      children: [
        {
          type: "tabset",
          weight: 15,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: "Explorer",
              component: "fileTree",
              enableClose: false
            }
          ]
        },
        {
          type: "row",
          weight: 85,
          children: [
            {
              type: "tabset",
              weight: 60,
              children: [
                {
                  type: "tab",
                  name: "Editor",
                  component: "editor",
                  enableClose: false
                }
              ]
            },
            {
              type: "tabset",
              weight: 40,
              children: [
                {
                  type: "tab",
                  name: "Terminal",
                  component: "terminal",
                  enableClose: false
                }
              ]
            }
          ]
        }
      ]
    }
  };

  const model = Model.fromJson(json);

  // Component factory
  const factory = (node: any) => {
    const component = node.getComponent();
    switch (component) {
      case "fileTree":
        return <SimpleFileTree />;
      case "editor":
        return <EditorArea />;
      case "terminal":
        return <TerminalEmulator />;
      default:
        return null;
    }
  };

  return (
    <div className="flexlayout-container h-screen w-screen" style={{ height: '100vh', width: '100vw' }}>
      <Layout
        model={model}
        factory={factory}
        onAction={(action) => {
          // Handle layout actions if needed
          return action;
        }}
      />
    </div>
  );
};

export default LayoutManager;